import { render } from "./EpochDisplay.vue?vue&type=template&id=360ffd9f&scoped=true"
import script from "./EpochDisplay.vue?vue&type=script&lang=js"
export * from "./EpochDisplay.vue?vue&type=script&lang=js"

import "./EpochDisplay.vue?vue&type=style&index=0&id=360ffd9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360ffd9f"]])

export default __exports__